export default {
  firebase: {
    apiKey: "AIzaSyAZ7_cdbT1pWiKqiSpKPuhRrRdx35BetqI",
  authDomain: "itm-ihm-certification-verify.firebaseapp.com",
  databaseURL: "https://itm-ihm-certification-verify.firebaseio.com",
  projectId: "itm-ihm-certification-verify",
  storageBucket: "itm-ihm-certification-verify.appspot.com",
  messagingSenderId: "394091058693",
  appId: "1:394091058693:web:c70275e81658262bcdae6c",
  measurementId: "G-NE5MFJ3ZVZ"
  }
}



// WEBPACK FOOTER //
// ./src/env.staging.js